<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item> 中期检查 </el-breadcrumb-item>
      <el-breadcrumb-item>管理员审核</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-select v-model="projectCategory" placeholder="请选择课题类别" @change="getProjectInfo">
        <el-option v-for="item in projectCategorys" :key="item.id" :label="item.name" :value="item.name">
        </el-option>
      </el-select>


      <!-- 申报书列表 -->
      <div v-for="item in projectAssess" :key="item.direction">
        <h3>课题方向： {{ item.direction }}</h3>
        <el-table :data="item.data" style="width: 100%">
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column prop="leader_name" label="作者" width="120"></el-table-column>
          <el-table-column prop="category_direction" label="课题方向" width="180"></el-table-column>
          <el-table-column prop="new_name" label="课题名称" width="300"></el-table-column>
          <el-table-column prop="new_pid" label="课题新编号" width="180"></el-table-column>
          <el-table-column prop="status" label="课题状态" width="100"></el-table-column>
          <el-table-column label="查看" width="50">
            <template slot-scope="scope">
              <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                @click="showInfoForm(scope.row)">
              </el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="total_score" label="总分" width="50"> </el-table-column> -->
          <el-table-column label="详情" width="150">
            <template slot-scope="scope">
              <el-button size="mini" :plain="true" type="primary" @click="assessButton(scope.row)">详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>

    <!-- 申报书查看 -->
    <el-card v-show="infoFormVisible" id="id-el-card-info">
      <!--  <el-row>
        <el-col :span="24">
          <div class="header-edit">申报书详情</div>
        </el-col>
      </el-row>
      <el-card>
        <el-col class="el-col-addForm">
          <span> 课题类别：</span>
          <el-input :disabled="true" v-model="editForm.category_direction"></el-input>
          <span> 课题名称：</span>
          <el-input :disabled="true" v-model="editForm.name"></el-input>
        </el-col>
      </el-card> -->

      <!-- 预期成果形式 -->
      <!-- <el-card>
        <el-row class="el-row-detail">
          <el-col :span="8"><span> 预期成果形式：</span>
            <el-input :disabled="true" v-model="editForm.result_type"></el-input>
          </el-col>
          <el-col :span="8"><span> 字数：</span>
            <el-input :disabled="true" v-model="editForm.total_words"></el-input>
          </el-col>
          <el-col :span="8"><span> 预计完成时间：</span>
            <el-input :disabled="true" v-model="editForm.complete_time"></el-input>
          </el-col>
        </el-row>
      </el-card> -->
      <!-- 课题研究计划 -->
      <el-card>
        <!-- <div>课题研究计划</div>
        <quill-editor :disabled="true" v-model="editForm.content" :options="editorOption" class="editor"></quill-editor> -->
        <!-- 文件列表 -->
        <div class="div-file">
          <el-table :data="fileList" style="width: 551px" :header-cell-style="{ background: '#fafafa' }">
            <el-table-column prop="name" label="文件名" width="300"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150">
              <template slot-scope="scope">
                {{ scope.row.create_time | fmtdate }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                  @click="getFileCode(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <h3>保密协议及计划任务书</h3>
        <div class="div-file">
          <el-table :data="fileListSignAgreement" style="width:551px;" :header-cell-style="{ background: '#fafafa' }">
            <el-table-column prop="name" label="文件名" width="300"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150">
              <template slot-scope="scope">
                {{ scope.row.create_time | fmtdate }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                  @click="getFileCode(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <h3>阶段成果报告</h3>
        <div class="div-file">
          <el-table :data="fileListMiddleCheck" style="width:551px;" :header-cell-style="{ background: '#fafafa' }">
            <el-table-column prop="name" label="文件名" width="300"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150">
              <template slot-scope="scope">
                {{ scope.row.create_time | fmtdate }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                  @click="getFileCode(scope.row)">
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
    </el-card>

    <!-- 计算结果 -->
    <el-card v-show="computeCardVisible">
      <!-- 财务专家意见 -->
      <el-table :data="financeResult" class="coach-result">
        <el-table-column prop="finance_name" label="财务专家" width="100"></el-table-column>
        <el-table-column label="评分" width="100">
          <template slot-scope="scope">
            <div v-html="scope.row.finance_result.totalScore"></div>
          </template>
        </el-table-column>
        <el-table-column label="意见资金审核评议情况说明" width="300">
          <template slot-scope="scope">
            <div style="white-space: pre-line;" v-html="scope.row.finance_result.assessSuggestion"></div>
          </template>
        </el-table-column>
        <el-table-column prop="assess_date" label="评审时间" width="180"></el-table-column>
        <!-- <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="mini" :plain="true" type="danger" icon="el-icon-delete" circle
              @click="deleteFinanceResult(scope.row)"></el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </el-card>
    <!-- 专家 -->
    <el-card v-show="computeCardVisible">
      <el-table :data="assessResult" style="width: 100%">
        <el-table-column prop="assessor_name" label="专家" width="180"></el-table-column>
        <!-- 打分详情 -->
        <el-table-column type="expand" label="展开" width="380">
          <template slot-scope="scope">
            <el-table :data="scope.row.assessor_result.assessScore">
              <el-table-column prop="name" label="评分项" width="250"></el-table-column>

              <el-table-column prop="score" label="评分详情" width="400">
                <template slot-scope="scope1">
                  <el-radio-group v-model="scope1.row.score" v-for="item in scope1.row.scores" :key="item.score">
                    <el-radio style="margin-right: 20px" :label="item.score" disabled>
                      {{ item.name }}
                    </el-radio>
                  </el-radio-group>
                </template>
              </el-table-column>

              <el-table-column prop="score" label="得分"></el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column label="评审意见" width="280">
          <template slot-scope="scope">
            {{ scope.row.assessor_result.assessSuggestion }}
          </template>
        </el-table-column>
        <el-table-column prop="assess_date" label="评审时间" width="180"></el-table-column>
        <!-- <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="mini" :plain="true" type="danger" icon="el-icon-delete" circle
              @click="deleteAssessResult(scope.row)"></el-button>
          </template>
        </el-table-column> -->
      </el-table>

    </el-card>
    <el-card v-show="computeCardVisible">
      <!-- 教练意见 -->
      <el-table :data="coachResult" class="coach-result">
        <el-table-column prop="coach_name" label="教练/项目管理员" width="180"></el-table-column>
        <el-table-column label="意见" width="300">
          <template slot-scope="scope">
            <div style="white-space: pre-line;" v-html="scope.row.coach_result.assessSuggestion"></div>
          </template>
        </el-table-column>
        <el-table-column prop="assess_date" label="评审时间" width="180"></el-table-column>
      </el-table>
    </el-card>
    <el-button type="primary" style="margin-top: 30px" v-show="computeCardVisible" @click="genPdf()">生成最终报告</el-button>
    <el-button type="primary" style="margin-top: 30px" v-show="computeCardVisible" @click="completeVisible = true">
      中期检查通过
    </el-button>


    <!-- 文件列表 评审结果 -->
    <div class="div-file">
      <el-table :data="fileListAssess" style="width: 601px" :show-header="false"
        :header-cell-style="{ background: '#fafafa' }">
        <el-table-column prop="name" label="文件名" width="300"></el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="150">
          <template slot-scope="scope">
            {{ scope.row.create_time | fmtdate }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
              @click="getPdfCode(scope.row)"></el-button>
            <el-button size="mini" :plain="true" type="primary" icon="el-icon-download" circle
              @click="downloadFile(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- pdf查看 -->
    <el-dialog :visible.sync="pdfVisible" width="80%" :style="{ top: '-150px' }">
      <div class="onlineHelp cg-box">
        <div class="tools">
          <el-button type="mini" @click="zoomIn">放大</el-button>
          <el-button type="mini" @click="zoomOut">缩小</el-button>
        </div>
        <iframe :src="pdfSrc" width="100%" :height="iframeHeight" style="border:none;"></iframe>
      </div>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="completeVisible" width="30%">
      <span>确定通过中期检查？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="completeVisible = false">取 消</el-button>
        <el-button type="primary" @click="completeMiddleCheck">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
//富文本
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import * as Quill from 'quill'
import {
  quillEditor
} from 'vue-quill-editor'
import {
  ImageDrop
} from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)

//下载
import fileDownload from 'js-file-download'

// pdf预览
import pdf from 'vue-pdf'

export default {
  components: {
    quillEditor,
    pdf
  },
  data() {
    return {
      //pdf显示
      pdfSrc: '', // PDF 文件的 URL
      pdfVisible: false, // 控制 PDF 弹窗显示
      iframeHeight: '800px', // iframe 的高度，可以通过 zoomIn 和 zoomOut 来调整


      //课题类别下拉框
      projectCategorys: [],
      projectCategory: '',

      editContent: '',
      pid: '',
      userid: '',
      infoFormVisible: false,
      editForm: {}, //编辑申报书
      fileList: [], //附件列表
      fileListSignAgreement: [], //保密协议及计划任务书
      fileListMiddleCheck: [], //中期检查
      // qill-editor
      editorOption: {},
      projectAssess: [], //课题列表
      computeCardVisible: false,
      assessResult: [], //专家评审详情
      computeResult: {},
      projectAssessUpdate: {}, //删除某专家评审意见时用,更新projectAssess

      coachResult: [], //教练评审结果, 初始化成数组，因为用表来显示

      // 20240325 财务专家显示
      financeResult: [],

      projectAssessCompute: {}, //生成最后结果时需要的课题信息，点击“计算”按钮传入，点击“生成最后结果”使用
      fileListAssess: [], //管理员下载文件列表，加入了评审结果

      pngDialogVisible: false, //查看最终结果文件对话框
      finalPdfPng: [], //最终结果文件的图片
      projectInfoSignAgreement: {}, //点击评审完成按钮，需要修改 status 的 projectInfo ，因为异步，需要 watch

      // 通过检查 对话框
      completeVisible: false
    }
  },

  created() {
    this.userid = localStorage.getItem('userid')
    this.getProjectCategory()
  },


  methods: {
    //获取课题类别
    async getProjectCategory() {
      const res = await this.axios.get(`/projectCategory/`)
      if (res.status === 200) {
        this.projectCategorys = res.data.results

      }
    },

    // 课题类别下拉框
    async getProjectInfo() {
      this.projectAssess = []
      this.infoFormVisible = false
      this.computeCardVisible = false

      //select的value不能绑定对象，所以循环课题类别，找出projectCategory对应的记录
      let directions = []
      for (let i = 0; i < this.projectCategorys.length; i++) {
        if (this.projectCategorys[i].name == this.projectCategory) {
          directions = this.projectCategorys[i].direction
        }
      }
      // 循环课题方向，取出每个方向的课题加入列表
      for (let i = 0; i < directions.data.length; i++) {
        let url =
          `projectMiddleCheckDistinct/?category=${this.projectCategory}&category_direction=${directions.data[i].name}&ordering=pid`
        let resInfo = await this.axios.get(url)
        if (resInfo.status == 200) {
          let data = resInfo.data.results
          console.log(data)
          this.projectAssess.push({
            direction: directions.data[i].name,
            data: data
          })
        }
      }
    },


    // 获取附件列表
    async getFileList(pid) {
      this.fileList = []
      this.fileListSignAgreement = []
      this.fileListMiddleCheck = []

      const res = await this.axios.get(`/fileList/?pid=${pid}`)
      if (res.status === 200) {
        this.fileList = res.data.results
      } else {
        this.$message.warning('获取文件列表错误')
      }
      // 保密协议、计划任务书
      const resAgreement = await this.axios.get(`/fileList/?pid=${pid}` + '/保密协议及计划任务书')
      if (resAgreement.status === 200) {
        this.fileListSignAgreement = resAgreement.data.results
      } else {
        this.$message.warning("获取文件列表错误")
      }
      // 中期检查
      const resMiddle = await this.axios.get(`/fileList/?pid=${pid}` + '/中期检查阶段成果报告')
      if (resMiddle.status === 200) {
        this.fileListMiddleCheck = resMiddle.data.results
      } else {
        this.$message.warning("获取文件列表错误")
      }
    },

    // 显示查看申报书卡片（）
    async showInfoForm(item) {
      this.infoFormVisible = !this.infoFormVisible
      let res = await this.axios.get('/projectInfo/?pid=' + item.pid)
      this.editForm = res.data.results[0]
      this.getFileList(item.pid)

      setTimeout(() => {
        document.getElementById('id-el-card-info').scrollIntoView({
          behavior: 'smooth'
        })
      }, 500)
    },

    // 下载文件
    downloadFile(item) {
      let url = `/downloadFile/?path=${item.path}&name=${item.name}`
      let params = {
        path: item.path,
        name: item.name
      }
      this.axios
        .post(url, params, {
          responseType: 'arraybuffer'
        })
        .then(res => {
          fileDownload(res.data, item.name)
        })
    },


    // 判断文件类型，调用不同的查看方法
    getFileCode(item) {
      let name = item.name.slice(-3)
      if (name == 'jpg' || name == 'png' || name == 'bpm') {
        // this.getPicCode(item)
      } else if (name == 'pdf') {
        this.getPdfCode(item)
      } else if (name == 'mp4') {
        // this.getVideoCode(item)
      }
    },


    // pdf预览
    // 初始化获取pdf文件
    getPdfCode(item) {
      this.pdfVisible = true;  // 显示弹窗
      let url = `/downloadFile/?path=${item.path}&name=${item.name}`;
      let params = {
        path: item.path,
        name: item.name
      };

      this.axios({
        method: 'post',
        url: url,
        data: params,
        responseType: 'blob' // 设置响应的数据类型为 Blob
      }).then(response => {
        // 检查是否为 PDF 文件
        const file = response.data;
        const blob = new Blob([file], { type: 'application/pdf' }); // 确保 MIME 类型是 PDF
        this.pdfSrc = URL.createObjectURL(blob); // 创建可供 iframe 使用的 URL
      }).catch(error => {
        console.error("加载 PDF 文件失败:", error);
      });
    },

    // 将 Blob 转换为 URL
    createPdfObjectURL(file) {
      return URL.createObjectURL(file); // 使用 URL.createObjectURL 创建可访问的文件 URL
    },
    // 放大 PDF
    zoomIn() {
      let currentHeight = parseInt(this.iframeHeight);
      this.iframeHeight = `${currentHeight + 100}px`; // 每次放大100px
    },
    // 缩小 PDF
    zoomOut() {
      let currentHeight = parseInt(this.iframeHeight);
      this.iframeHeight = `${Math.max(currentHeight - 100, 300)}px`; // 最小缩小到300px
    },


    //详情按钮
    async assessButton(item) {
      // 清空文件列表
      this.fileListAssess = []

      //生成最后结果时需要的课题信息
      let res = await this.axios.get('/projectMiddleCheck/' + '?pid=' + item.pid)

      let data = []
      this.assessResult = []
      this.coachResult = []
      this.financeResult = []

      if (res.status == 200) {
        data = res.data.results
        for (let i = 0; i < data.length; i++) {
          if (data[i].assessor) {
            this.assessResult.push(data[i])
          }
          if (data[i].coach) {
            this.coachResult.push(data[i])
          }
          if (data[i].finance) {
            this.financeResult.push(data[i])
            // console.log("fff:", this.financeResult)
          }
        }
      }

      this.infoFormVisible = false
      this.computeCardVisible = true

      // 传入pid，完成按钮要修改project的status
      this.projectAssessCompute = item
      // 传入pid，delete某专家评审结果时需要
      // this.projectAssessUpdate = item

      // this.computeResult = {
      //   assessors: this.assessResult.data.length,
      //   score: score,
      // }
    },


    // 删除某个评审结果（通知专家重新评审）
    async deleteAssessResult(item) {
      console.log('delete', item)
      return
      this.$confirm('此操作将做删除动作, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let id = this.projectAssessUpdate.id
        let resDel = await this.axios.put(`/projectMiddleCheck/${id}/`)
        if (resDel.status = 204) {
          // 添加分配表，重新评审
          let resProjctInfo = await this.axios.get(`/projectInfoLite/?pid=${this.projectAssessUpdate.pid}`)
          if (resProjctInfo.status == 200) {
            let p = resProjctInfo.data.results[0]
            let dataTemp = {
              pid: this.projectAssessUpdate.pid,
              pname: this.projectAssessUpdate.pname,
              assessor: item.assessor,
              aname: item.aname,
              leader: p.leader,
              leader_name: p.leader_name,
              category: p.category,
              category_direction: p.category_direction,
              status: "中期检查"
            }
            let resPost = await this.axios.post('/projectDistribute/', dataTemp)
            if (resPost.status == 201) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
            }
          }
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      });
    },

    //生成最后报告
    async genPdf() {
      // // 20230606 为每个项目生成报告，暂时取消限制
      // if (!this.projectAssessCompute.finance_result) {
      //   return this.$message.error("请财务专家先进行评审，再进行生成！");
      // }

      // console.log(this.coachResult)
      // if (!this.coachResult[0].cname) {
      //   return this.$message.error('教练意见为空，请先做用户评定！')
      // }
      // 使用loading加载，客户等待
      const loading = this.$loading({
        lock: true, //lock的修改符--默认是false
        text: "Loading", //显示在加载图标下方的加载文案
        spinner: "el-icon-loading", //自定义加载图标类名
        background: "rgba(0, 0, 0, 0.7)", //遮罩层颜色
        target: document.querySelector("#table") //loadin覆盖的dom元素节点
      });

      let dataGenPdf = {
        project: this.projectAssessCompute,
        assessor_result: this.assessResult,
        coach_result: this.coachResult,
        finance_result: this.financeResult
      }
      let res = await this.axios.post(
        "/genPdfMidleCheck2023/",
        dataGenPdf
      );

      res = res.data;

      // 获取文件列表
      this.fileListAssess = [];
      this.getFileList(this.projectAssessCompute.pid);
      this.fileListAssess.push(res);

      //11-28 取消
      // 生成最终pdf的png，供页面上查看
      // this.pdfToPng()
      // 获取png
      // this.getProjectInfoPng(this.projectAssessCompute.pid)

      //成功回调函数停止加载
      loading.close();
    },

    // 完成中期检查
    async completeMiddleCheck() {
      this.completeVisible = false
      try {
        // 修改 projectInfo 状态为9，中期检查通过，待结题
        let info = {}
        let resget = await this.axios.get(`/projectInfo/?pid=${this.projectAssessCompute.pid}`)
        if (resget.status === 200) {
          info = resget.data.results[0]
        }

        // 状态不是8，不能修改
        if (info.status != 8) {
          return this.$message.error("课题不是“待中期评审状态”，不能修改！")
        }

        info.status = 9
        let resput = await this.axios.put(`/projectInfo/${info.id}/`, info)
        if (resput.status !== 200) {
          return this.$message.error('更新数据失败，请重试！')
        }
        // 修改 projectMiddleCheck status='中期检查通过，待结题'
        let infoMiddle = []
        let resget1 = await this.axios.get(`/projectMiddleCheck/?pid=${this.projectAssessCompute.pid}`)
        if (resget1.status === 200) {
          infoMiddle = resget1.data.results
          console.log('infoMiddle', infoMiddle)
        }
        for (let i = 0; i < infoMiddle.length; i++) {
          infoMiddle[i].status = '中期检查通过，待结题'
          let resput1 = await this.axios.put(`/projectMiddleCheck/${infoMiddle[i].id}/`, infoMiddle[i])
          if (resput1.status !== 200) {
            return this.$message.error('更新数据失败，请重试！')
          }
        }
      } catch (err) {
        return this.$message.error(err)
      }
      setTimeout(() => {
        location.reload()
      }, 500)
    }
  }
}

</script>

<style lang="less">
.el-card {
  margin-top: 15px;
}

.header-edit {
  font-size: 18px;
  text-align: left;
  margin-bottom: 10px;
}

.el-col-user-add {
  display: flex;
}

.user-search {
  width: 420px;
  margin-right: 10px;
}

.el-col-addForm {
  display: flex;
  margin-bottom: 10px;

  span {
    display: flex;
    align-items: center;
    margin-left: 10px;
  }

  .el-input {
    width: 400px;
  }
}

.el-card-leader {
  .div-leader {
    font-size: 16px;
    margin-bottom: 15px;
  }
}

.member {
  font-size: 16px;
  margin-bottom: 15px;
}

.el-row-detail {
  width: 1020px;

  .el-col {
    display: flex;

    span {
      display: flex;
      align-items: center;
      margin-left: 10px;
    }

    .el-input {
      width: 200px;
    }
  }
}

.editor {
  margin-top: 15px;
}

.ql-editor {
  min-height: 200px;
}

.div-upload {
  width: 500px;
  padding-top: 10px;
}

.div-add {
  margin-top: 20px;
  display: flex;
  justify-content: end;
}

.div-file {
  margin-top: 15px;
}

.div-compute {
  margin-top: 20px;

  span {
    margin-right: 20px;
  }
}

.coach-result {
  margin-top: 20px;
  width: 100%;
}

// pdf预览
.onlineHelp {
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;

  .tools {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 999;
    margin-top: -50px;

    .page {
      display: inline-block;
      margin-right: 10px;
    }
  }

  .pdf-box {
    height: 100%;
    overflow: auto;
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/middleCheck/MiddleCheckAdmin.vue